import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config';
import './agent.css';

var PLATFORM_OPTIONS = ['Google Ads', 'Facebook/Meta', 'Instagram', 'Amazon', 'Shopify', 'LinkedIn', 'Twitter/X', 'TikTok', 'YouTube', 'Klaviyo', 'Email Marketing', 'SEO/Organic'];
var GOAL_OPTIONS = ['Brand Awareness', 'Lead Generation', 'Sales/Revenue', 'SEO Rankings', 'Social Media Growth', 'Customer Retention', 'Product Launch', 'Market Expansion'];

function OnboardingPage() {
  var navigate = useNavigate();
  var [step, setStep] = useState(1);
  var [loading, setLoading] = useState(false);
  var [error, setError] = useState('');
  var [form, setForm] = useState({
    business_name: '', industry: '', website_url: '', target_audience: '',
    competitors: ['', '', ''], platforms: [], goals: [],
    monthly_budget: '', brand_voice: '', additional_notes: '',
  });

  function update(field, value) {
    setForm(Object.assign({}, form, { [field]: value }));
  }

  function toggleArray(field, value) {
    var arr = form[field];
    var next = arr.includes(value) ? arr.filter(function(v) { return v !== value; }) : arr.concat(value);
    update(field, next);
  }

  function updateCompetitor(index, value) {
    var c = form.competitors.slice();
    c[index] = value;
    update('competitors', c);
  }

  async function handleSubmit() {
    setLoading(true);
    setError('');
    var token = localStorage.getItem('agent_token');
    var body = Object.assign({}, form, {
      competitors: form.competitors.filter(function(c) { return c.trim(); }),
    });

    try {
      var res = await fetch(API_BASE_URL + '/api/projects', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(body),
      });
      var data = await res.json();
      if (!res.ok) { setError(data.error); setLoading(false); return; }
      navigate('/agent/dashboard/' + data.project.id);
    } catch (err) { setError('Network error'); }
    setLoading(false);
  }

  return (
    <div className="agent-onboarding">
      <div className="agent-onboarding-card">
        <div className="agent-steps-indicator">
          {[1,2,3].map(function(s) {
            return <div key={s} className={'agent-step-dot' + (s === step ? ' active' : '') + (s < step ? ' done' : '')} />;
          })}
        </div>

        {step === 1 && (
          <div className="agent-step">
            <h2>Tell us about your business</h2>
            <input className="agent-input" placeholder="Business name *" value={form.business_name}
              onChange={function(e) { update('business_name', e.target.value); }} />
            <input className="agent-input" placeholder="Industry (e.g. SaaS, E-commerce, Health)" value={form.industry}
              onChange={function(e) { update('industry', e.target.value); }} />
            <input className="agent-input" placeholder="Website URL" value={form.website_url}
              onChange={function(e) { update('website_url', e.target.value); }} />
            <textarea className="agent-input agent-textarea" placeholder="Describe your target audience"
              value={form.target_audience} onChange={function(e) { update('target_audience', e.target.value); }} />
            <button className="agent-btn-primary" disabled={!form.business_name.trim()}
              onClick={function() { setStep(2); }}>Next</button>
          </div>
        )}

        {step === 2 && (
          <div className="agent-step">
            <h2>Competitors & Platforms</h2>
            <p className="agent-label">Top competitors</p>
            {form.competitors.map(function(c, i) {
              return <input key={i} className="agent-input" placeholder={'Competitor ' + (i + 1) + ' (name or URL)'}
                value={c} onChange={function(e) { updateCompetitor(i, e.target.value); }} />;
            })}
            <p className="agent-label">Active platforms</p>
            <div className="agent-chip-grid">
              {PLATFORM_OPTIONS.map(function(p) {
                return <button key={p} type="button"
                  className={'agent-chip' + (form.platforms.includes(p) ? ' selected' : '')}
                  onClick={function() { toggleArray('platforms', p); }}>{p}</button>;
              })}
            </div>
            <div className="agent-step-nav">
              <button className="agent-btn-secondary" onClick={function() { setStep(1); }}>Back</button>
              <button className="agent-btn-primary" onClick={function() { setStep(3); }}>Next</button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="agent-step">
            <h2>Goals & Brand</h2>
            <p className="agent-label">Marketing goals</p>
            <div className="agent-chip-grid">
              {GOAL_OPTIONS.map(function(g) {
                return <button key={g} type="button"
                  className={'agent-chip' + (form.goals.includes(g) ? ' selected' : '')}
                  onClick={function() { toggleArray('goals', g); }}>{g}</button>;
              })}
            </div>
            <select className="agent-input" value={form.monthly_budget}
              onChange={function(e) { update('monthly_budget', e.target.value); }}>
              <option value="">Monthly budget range</option>
              <option value="< $1,000">{'< $1,000'}</option>
              <option value="$1,000 - $5,000">$1,000 - $5,000</option>
              <option value="$5,000 - $20,000">$5,000 - $20,000</option>
              <option value="$20,000+">$20,000+</option>
            </select>
            <select className="agent-input" value={form.brand_voice}
              onChange={function(e) { update('brand_voice', e.target.value); }}>
              <option value="">Brand voice / tone</option>
              <option value="Professional & Authoritative">Professional & Authoritative</option>
              <option value="Friendly & Conversational">Friendly & Conversational</option>
              <option value="Bold & Edgy">Bold & Edgy</option>
              <option value="Minimal & Clean">Minimal & Clean</option>
              <option value="Playful & Fun">Playful & Fun</option>
            </select>
            <textarea className="agent-input agent-textarea" placeholder="Anything else we should know?"
              value={form.additional_notes} onChange={function(e) { update('additional_notes', e.target.value); }} />

            {error && <p className="agent-error">{error}</p>}

            <div className="agent-step-nav">
              <button className="agent-btn-secondary" onClick={function() { setStep(2); }}>Back</button>
              <button className="agent-btn-primary" disabled={loading || !form.goals.length}
                onClick={handleSubmit}>{loading ? 'Setting up…' : 'Launch Dashboard'}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OnboardingPage;
